import api from "./api";
import { CartApiResponse, DeliveryMode, Order, PaymentMethod } from "../types/store";

export const checkout = async (payload: {
  deliveryMode: DeliveryMode;
  paymentMethod: PaymentMethod;
  shippingName: string;
  email: string;
  phone: string;
  addressId?: number | null;
  shippingAddress: string;
  addressSource?: string | null;
  addressMapUrl?: string | null;
  city: string;
  postalCode: string;
  deliverySlot?: string;
  priorityOrder: boolean;
  priorityNotes?: string;
  useWalletBalance: boolean;
  walletAmountUsed?: number | null;
  couponApplied: boolean;
  couponCode?: string | null;
}) => {
  const response = await api.post<Order>("/orders/checkout", payload);
  return response.data;
};

export const fetchOrders = async () => {
  const response = await api.get<Order[]>("/orders");
  return response.data;
};

export const cancelOrder = async (orderId: number) => {
  const response = await api.post<Order>(`/orders/${orderId}/cancel`);
  return response.data;
};

export const reorderOrder = async (orderId: number) => {
  const response = await api.post<CartApiResponse>(`/orders/${orderId}/reorder`);
  return response.data;
};
